const config = {
    apiURL: process.env.REACT_APP_API_URL,
    PEER_HOST: process.env.REACT_APP_PEER_HOST,
    PEER_PORT: process.env.REACT_APP_PEER_PORT,
    SOCKET_ADDRESS: process.env.REACT_APP_SOCKET_ADDRESS
};

export default config;